import { Outlet, useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import GlobalShortcuts from './GlobalShortcuts';
import StarfieldCanvas from '../ui/StarfieldCanvas';

export default function Layout() {
  const location = useLocation();
  const { pathname } = location;
  const isFullBleed =
    location.pathname === '/' || 
    location.pathname.startsWith('/movie/') || 
    location.pathname.startsWith('/tv/');

  return (
    <div className="min-h-screen bg-[#030203] text-white flex flex-col relative overflow-x-hidden">
      {/* SOTA Starfield & Swarm Network */}
      <StarfieldCanvas />

      {/* Ambient violet nebula — dialed back so the film art leads, not the chrome.
          (Starfield stays as the one quiet signature; the drifting volumetric
          god-ray layer was removed — restraint: one signature beats many effects.) */}
      <div
        className="fixed inset-0 pointer-events-none z-0 opacity-[0.22] mix-blend-screen"
        style={{
          background: "radial-gradient(circle at 82% 12%, rgba(139, 92, 246, 0.07) 0%, transparent 48%), radial-gradient(circle at 18% 85%, rgba(99, 102, 241, 0.05) 0%, transparent 58%)"
        }}
      />

      <Navbar />

      <main
        key={pathname}
        className="flex-1 relative z-10 page-enter"
        style={isFullBleed ? undefined : { paddingTop: '96px' }}
      >
        <Outlet />
      </main>
      <Footer />
      <GlobalShortcuts />
    </div>
  );
}
